import React, { ReactElement } from 'react';

import ContractLayout from 'pricing/components/contract/contractLayout/ContractLayout';
import ContractEditContent from 'pricing/pages/contractEdit/contractEditContent/ContractEditContent';

function ContractEdit(): ReactElement {
  return (
    <ContractLayout>
      <ContractEditContent />
    </ContractLayout>
  );
}

export default ContractEdit;
